import axiosInstance from '../../../config/axiosInstance';
const  CustomerDiscountService = {
    async GetCustomerCategoryDiscount(redirectCallback,ClientCompanyID) {
        try {            
           
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetCustomerCategoryDiscount?ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
   async DeleteCustomerCategoryDiscount(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Customer/DeleteCustomerCategoryDiscount?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default CustomerDiscountService;